// .js
import React, {PropTypes} from "react";
import {connect} from 'react-redux';

class FeedbackTextArea extends React.Component {
	render() {
			const {label,id,required} = this.props;
			return (
                        <div>
                        <h4><span id="js-feedback-title">{label}</span></h4>

                            <div className="form">
                            <textarea
                              required={required}
                              data-questionId={id} name={label} className="textArea"></textarea>
                            </div>
                              </div>
);
	}
}
export default FeedbackTextArea;



/** WEBPACK FOOTER **
 ** ./src/feature/feedback/feedbackTextArea.js
 **/